<script>
  export default {
    name: 'card-basic',
    props: {
      cardProps: {
        type: Object,
        default: () => ({})
      },
      item: {
        type: Object,
        required: true
      },
      orientation: {
        type: String,
        required: false
      }
    }
    // computed: {
    //   orientationClasses() {
    //     if (!this.orientation) {
    //       return 'flex-column flex-sm-row align-stretch justify-center justify-sm-start'
    //     }

    //     if (this.orientation === 'horizontal') {
    //       return 'flex-column  align-stretch  justify-start'
    //     }

    //     if (this.orientation === 'vertical') {
    //       return 'flex-column align-stretch justify-center '
    //     }
    //   }
    // }
  }
</script>
<!-- PICK UP HERE, SETUP RESPONSIVE CARD image/title/desc/ to card props     -->
<template>
  <v-sheet
    v-bind="{ ...cardProps }"
    max-width="850"
    width="100%"
    class="d-flex flex-column flex-sm-row align-stretch justify-center justify-sm-start rounded-lg text-decoration-none mt-4 pa-4"
  >
    <v-sheet height="100%" max-width="33%" min-width="33%" width="33%" class="d-flex align-start justify-center mx-auto mx-sm-0 mb-2 mb-sm-0 mr-sm-4 mr-md-0">
      <img :src="item.img" :alt="`logo for ${item.title}`" class="item-logo rounded-lg" />
    </v-sheet>
    <v-card flat title class="d-flex flex-column text-decoration-none">
      <v-card-title v-html="item.title" class="text-h5 primary--text font-weight-bold break-word text-decoration-none pa-0"></v-card-title>
      <v-card-text class="d-flex flex-column align-start justify-start text-decoration-none pa-0">
        <!-- <p v-if="item.price" class="text-body-1 font-weight-bold success--text">
          {{ item.price }}
          <span class="black--text text-caption font-weight-light">({{ item.expiration ? `expires ${item.expiration}` : 'no expiration' }})</span>
        </p>
        <p v-if="item.discount" class="text-body-1 font-weight-bold success--text">
          {{ item.discount }} discount<span v-if="item.expiration" class="black--text text-caption font-weight-light">({{ item.expiration }})</span>
        </p> -->
        <!-- <template v-if="item?.details?.length">
          <ul v-if="item?.details?.length > 1" class="py-4 py-sm-8" style="max-width: 150ch"> 
            <li v-for="(detail, k) in item.details" :key="k">{{ detail }}</li>
          </ul> 
          <p v-else class="py-8">{{ item.details[0] }}</p>
        </template> -->
        <p class="text-body-1 font-weight-bold py-4 py-sm-8">{{ item.details || '&nbsp;' }}</p>
      </v-card-text>
      <!-- <v-card-actions class="pt-4 pa-sm-0 mt-auto d-flex flex-row justify-space-start">
        <v-btn v-if="item.homepage" color="primary" :href="item.homepage" outlined target="_blank" class="font-weight-bold "
          ><v-icon left color="primary">mdi-home</v-icon>HOME</v-btn
        >
        <template v-if="item.item_url">
          <v-btn v-if="item.item_url === 'eipl'" color="primary"><v-icon left color="secondary">mdi-library-outline</v-icon>LIBRARY PICKUP</v-btn>
          <v-btn v-else color="primary" :href="item.item_url" target="_blank" class="font-weight-bold"
            ><v-icon left color="secondary">{{ `mdi-${isPass ? 'bank' : 'item-outline'}` }}</v-icon
            >{{ isPass ? 'RESERVE' : 'ITEMS' }}</v-btn
          >
        </template>
      </v-card-actions> -->
    </v-card>
  </v-sheet>
</template>

<style scoped>
  p {
    margin: 0;
  }

  .item-logo {
    object-fit: contain;
    /* border-radius: 50%; */
    height: 200px;
    width: 200px;
  }
</style>
